import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class Address extends AbstractModel {
  @autoserialize
  driverId: number;

  @autoserialize
  streetAddress1: string;

  @autoserialize
  streetAddress2: string;

  @autoserialize
  city: string;

  @autoserialize
  stateCode: string;

  @autoserialize
  zipCode: string;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;

  @autoserialize
  verified: boolean;

  @autoserialize
  active: boolean;

  equals(address: Address): boolean {
    return (
      this.streetAddress1 === address.streetAddress1 &&
      this.streetAddress2 === address.streetAddress2 &&
      this.city === address.city &&
      this.stateCode === address.stateCode &&
      this.zipCode === address.zipCode
    );
  }
}
